import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/template/redux/actions';
import * as pluginActions from '../../../features/plugin/redux/actions';
import { EditorState } from 'draft-js';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ParentDocCard from '../../common/ParentDocCard';
import { TemplateHeaderNav } from '../TemplateHeaderNav';
import { SOCKET_IO_TEMPLATE } from 'drapcode-constant';
import SocketIOTemplateForm from './SocketIOTemplateForm.js';

export class SocketIOTemplate extends Component {
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  toggle = (activeTab) => {
    this.setState({ activeTab: activeTab });
  };
  static propTypes = {
    template: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    editorState: EditorState.createEmpty(),
    name: '',
    subject: '',
    collectionId: '',
    selectedCollectionFields: [],
  };

  componentDidMount = () => {
    const { projectId, version } = this.props.match.params;
    const { pluginActions } = this.props;
    this.props.actions.loadCollections({ projectId, version });
    pluginActions.loadAllInstalledPlugin({ projectId, version });
  };

  handleSubmit = (values) => {
    const { projectId, version } = this.props.match.params;
    values.projectId = projectId;
    let args = {
      projectId,
      version,
      values: values,
    };
    this.props.actions.createSocketIoTemplate(args).then(() => {
      this.toggle(SOCKET_IO_TEMPLATE);
    });
  };
  toggle = (activeTab) => {
    const { projectId, version } = this.props.match.params;
    this.props.history.push({
      pathname: `/2.0/template/${version}/v/${projectId}`,
      state: { activeTab: activeTab },
    });
  };

  render() {
    const { state, props } = this;
    const { editorState, name, collectionId, selectedCollectionFields, subject } = state;
    const { template, plugin } = props;
    const { collections, createSocketIoTemplatePending } = template;
    const { installedPlugins } = plugin;
    console.log('this.props', props);
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <TemplateHeaderNav
              activeTab={SOCKET_IO_TEMPLATE}
              title={'Socket IO Templates'}
              toggle={this.toggle}
              installedPlugins={installedPlugins}
            />
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-dark-blue"
                  >
                    <i className={`wb ${drapcodeIcon(SOCKET_IO_TEMPLATE)}`}></i>
                  </div>
                  <div className="card-content">
                    <SocketIOTemplateForm
                      handleSubmit={this.handleSubmit}
                      editorState={editorState}
                      name={name}
                      subject={subject}
                      collectionId={collectionId}
                      collections={collections}
                      selectedCollectionFields={selectedCollectionFields}
                      createSocketIoTemplatePending={createSocketIoTemplatePending}
                    />
                  </div>
                </div>
              </div>
              <ParentDocCard>
                <h5>
                  <b>Socket IO Template</b>
                </h5>
                <p>
                  Create custom Socket.IO templates to display real-time data, such as notifications
                  or messages, in a layout that fits your application.
                </p>
                <br />
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template,
    plugin: state.plugin,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SocketIOTemplate);
